
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl=null, cancelToken=null) {
        const user = JSON.parse(localStorage.getItem('user'));
    
        //let url = `${API_URL}/production-user?page=${pageUrl}`;
        const queryString = new URLSearchParams(pageUrl).toString();
        let url = `${API_URL}/production-user?${queryString}`; 
    
        // Si el usuario tiene un role 3, agregar el user_id a la URL
        if(user && user.role === '3'){
            url += `&user_id=${user.id}`;
        }
    
        const config = { headers: authHeader() };
        if (cancelToken) {
            config.cancelToken = cancelToken;
        }
    
        return axios.get(url, config);
    },
    /** Reporte de nómina por producción / oficio / canasta. */
    getReport(params) {
        return axios.get(`${API_URL}/production-user/report`, { params, headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production-user/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/production-user`, data, { headers: authHeader() });
    },
    createFloating(data) {
        return axios.post(`${API_URL}/production-user/floating`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/production-user/${id}`, data, { headers: authHeader() });
    },
    /** Solo cantidad entregada (modal edición producción). */
    updateDeliveredQuantity(id, data) {
        return axios.patch(`${API_URL}/production-user/${id}/delivered-quantity`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/production-user/${id}`, { headers: authHeader() });
    },
    bulkMarkAsReceived(ids) {
        return axios.post(`${API_URL}/production-user/bulk/received`, { ids }, { headers: authHeader() });
    },
    bulkMarkAsDelivered(ids) {
        return axios.post(`${API_URL}/production-user/bulk/delivered`, { ids }, { headers: authHeader() });
    },
    bulkMarkAsValidated(ids) {
        return axios.post(`${API_URL}/production-user/bulk/validated`, { ids }, { headers: authHeader() });
    },
    /** Canastas de una producción con su historial de movimientos. */
    getBaskets(productionId) {
        return axios.get(`${API_URL}/production-basket`, { params: { production_id: productionId }, headers: authHeader() });
    },
    transferBaskets(data) {
        return axios.post(`${API_URL}/production-basket/transfer`, data, { headers: authHeader() });
    },
    /** Termina canastas: cierran donde están y ya no se envían a ningún oficio. */
    finishBaskets(data) {
        return axios.post(`${API_URL}/production-basket/finish`, data, { headers: authHeader() });
    },
    /** Reabre una canasta terminada (vuelve a la tarea donde se terminó). */
    reopenBasket(id) {
        return axios.post(`${API_URL}/production-basket/${id}/reopen`, {}, { headers: authHeader() });
    },
    /** Deshace el último movimiento de la canasta (elimina su tarea actual). */
    deleteBasketTask(id) {
        return axios.delete(`${API_URL}/production-basket-task/${id}`, { headers: authHeader() });
    },
    getPdf(id) {
        return axios.get(`${API_URL}/production-user/export-pdf/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
};
